// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__35QhG","selects":"Documents_selects__hal6Z"};